import { useState, useEffect, useCallback } from 'react';
import api from '../../../services/api';

// Skorlama Plan 4, Task 4 (task-4-brief.md) — Kurumsal Hedefler (OrgGoal) sayfası.
// Gerçek uçlar (Task 1-3'ten, grep ile doğrulanmış — brief metnindeki
// "v1/org-goals/options" BAYAT, gerçek seçici ucu period-goals/config'te ayrı
// ele alınır):
//   GET    v1/org-goals/tree?periodId=       (ağaç + rollup + hizalı hedef özeti)
//   POST   v1/org-goals                       (company/department — PM.Write)
//   PUT    v1/org-goals/{id}                  (company/department — PM.Write)
//   DELETE v1/org-goals/{id}                  (company/department — PM.Write)
//   POST   v1/org-goals/team                  (self-servis, sahiplik serviste)
//   PUT    v1/org-goals/team/{id}             (self-servis)
//   DELETE v1/org-goals/team/{id}             (self-servis)
// Request gövdesi (Create/Update ortak — OrgGoalRequest):
//   { periodId, ownerType, departmentId?, title, description?, parentOrgGoalId?,
//     progressMode, manualProgressPct? }

// OrgGoalDataAccess.ValidateParentAsync ile BİREBİR aynı hiyerarşi kuralı:
// company ebeveynsiz; department yalnız company'ye; team company|department'a
// hizalanabilir. Modal'ın "Üst Hedef" seçicisindeki adayları filtrelemek için.
export const getAllowedParentTypes = (ownerType) => {
  if (ownerType === 'department') return ['company'];
  if (ownerType === 'team') return ['company', 'department'];
  return [];
};

// GetTreeAsync'in döndürdüğü iç içe ağacı düz bir listeye çevirir — üst hedef
// seçicisi (parent picker) bu düz listeden ownerType'a göre filtreler; ayrı bir
// API çağrısı GEREKMEZ (ağaç zaten sayfada yüklü).
export const flattenTree = (nodes) => {
  const out = [];
  (nodes || []).forEach((n) => {
    out.push(n);
    if (n.children && n.children.length > 0) out.push(...flattenTree(n.children));
  });
  return out;
};

// GET — reference_api_interceptor_never_rejects_reads.md: interceptor okuma
// isteklerinde asla reddetmez (mutasyonlardan FARKLI), bu yüzden gerçek
// başarı/başarısızlık sinyali `res.data.status`'tür — `.catch()` burada ölü kod
// olurdu, bilinçli olarak YOK.
export default function useOrgGoalTree(periodId) {
  const [tree, setTree] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const refresh = useCallback(() => setRefreshTrigger((p) => p + 1), []);

  useEffect(() => {
    if (!periodId) {
      setTree([]);
      return;
    }
    setFetching(true);
    api.get('/v1/org-goals/tree', { params: { periodId } })
      .then((res) => {
        setTree(res.data?.status ? (res.data.data || []) : []);
      })
      .finally(() => setFetching(false));
  }, [periodId, refreshTrigger]);

  return {
    tree, fetching, refresh,
  };
}

// company/department → PM.Write yönetim uçları; team → self-servis uçlar
// (OrgGoalController'ın "team/" öneki — sahiplik OrgGoalDataAccess'te doğrulanır).
const orgGoalBasePath = (ownerType) => (ownerType === 'team' ? '/v1/org-goals/team' : '/v1/org-goals');

// Mutasyonlar — services/api.js interceptor'ı POST/PUT/DELETE'te BAŞARISIZLIKTA
// reddeder (toast zaten interceptor'da basılır) — bu yüzden try/catch → boolean
// deseni (usePeriodGoalsApi'nin createDraft/updateDraft/vb. ile BİREBİR aynı).
export const createOrgGoal = async (ownerType, payload) => {
  try {
    await api.post(orgGoalBasePath(ownerType), payload);
    return true;
  } catch {
    return false;
  }
};

export const updateOrgGoal = async (id, ownerType, payload) => {
  try {
    await api.put(`${orgGoalBasePath(ownerType)}/${id}`, payload);
    return true;
  } catch {
    return false;
  }
};

export const archiveOrgGoal = async (id, ownerType) => {
  try {
    await api.delete(`${orgGoalBasePath(ownerType)}/${id}`);
    return true;
  } catch {
    return false;
  }
};

// PeriodWizard.js'in searchDepartments'ıyla BİREBİR aynı çağrı (brief: "PeriodWizard/
// başka sayfa nasıl çekiyorsa aynı hook/çağrı") — departman hedefi oluştururken
// AsyncGenericSelect'in onSearch'ü.
export const searchDepartments = async (term) => {
  const params = term ? { 'name[like]': term, pageSize: 20 } : { pageSize: 20 };
  const res = await api.get('/v1/departments', { params });
  return (res.data?.data?.data || []).map((d) => ({ id: d.id, name: d.name }));
};
